import { useTranslation } from "react-i18next";
import "../../assets/styles/bootstrap.css";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import ReadMoreContainer from "../containers/ReadMoreContainer";
import { TRUNCATE } from "../../config/defaultValues";

function GraveListElement(grave) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  grave = grave.grave;

  const handleClick = (uuid) => {
    navigate("/gravedetails", { state: { uuid: uuid } });
  };

  return (
    <>
      <div
        className="ms-2 me-auto"
        style={{ animation: "appear 5s linear" }}
      >
        <div
          className="fw-bolder lh-lg fs-6"
          style={{ cursor: "pointer" }}
          onClick={() => handleClick(grave.uuid)}
        >
          {grave?.identifier && ` ${grave?.identifier} `}
          {grave?.graveType?.typeName &&
            ` ${grave?.graveType?.typeName} `}
        </div>
        {grave?.departedList?.length > 0 &&
          <div
            className={"fw-medium lh-sm"}
            style={{ cursor: "pointer" }}
            onClick={() => handleClick(grave.uuid)}
          >
            {grave?.departedList?.map((departed)=>{
              return <>{departed?.namePrefix ? departed?.namePrefix + ' ' : ''}{departed?.familyName + ' '}{departed?.bornFamilyName ? '(' + departed?.bornFamilyName + ') ' : ''}{departed?.givenName} ({(departed?.bornYear) ? departed?.bornYear : '?'} - {departed?.deathYear ? departed?.deathYear : '?'}) <br/></>
            })}
          </div>
        }
        <ReadMoreContainer
          truncate={TRUNCATE}
          style={{ padding: "3px", "padding-left": "5px" }}
          showMoreText={t("more")}
          showLessText={t("less")}
        >
          {grave?.description && (grave.description.length > 100) ? (`${grave?.description.slice(0, 100)}...`) : (grave?.description)}
        </ReadMoreContainer>
      </div>
      <Button
        variant="link"
        className="more-btn more-btn:hover"
        style={{ textDecoration: "none", color: 'grey' }}
        onClick={() => handleClick(grave.uuid)}
      >
        {t("more")}
      </Button>
    </>
  );
}

export default GraveListElement;